import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24c8bda0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=24c8bda0&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=24c8bda0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f1c606d12331ca9397f00d9371f47138/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c8bda0",
  null
  
)

export default component.exports